import React from 'react';
import PropTypes from 'prop-types';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';

class AccountsEditForm extends React.Component {
    componentDidMount() {
        const { data, initialize } = this.props;

        initialize(data);
    }

    componentDidUpdate(prevProps) {
        const prevData = prevProps.data;
        const { data } = this.props;

        if (utils.get(prevData, 'id') !== utils.get(data, 'id')) {
            const { initialize } = this.props;

            initialize(data);
        }
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            submitting,
            translate,
        } = this.props;

        const canEdit = authHelper.isOwner() || authHelper.isAdmin();

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.accounts.forms.account') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ !canEdit }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.name') }
                                    name='name'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.email') }
                                    name='email'
                                    validate={ validations.required }
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.phone') }
                                    name='phone'
                                    source='phone'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.accounts.forms.address') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.address') }
                                    name='address'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.zipcode') }
                                    name='zipcode'
                                    validate={ validations.required }
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.city') }
                                    name='city'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.country') }
                                    name='country'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.accounts.forms.registrations') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.vat') }
                                    name='vat'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.iban') }
                                    name='iban'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.bic') }
                                    name='bic'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.registration') }
                                    name='registration'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.accounts.fields.contact_details') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.contact_phone') }
                                    name='contact_phone'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.contact_email') }
                                    name='contact_email'
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.contact_whatsapp') }
                                    name='contact_whatsapp'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.contact_emergency_phone') }
                                    name='contact_emergency_phone'
                                />
                            </Item>

                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

AccountsEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            const {
                contact_phone,
                contact_email,
                contact_emergency_phone,
                contact_whatsapp,
            } = { ...values };

            const isContactValuesValid = contact_phone || contact_email || contact_emergency_phone || contact_whatsapp;

            if (!isContactValuesValid) {
                errors.contact_email = translate('forms.one_of_them_required');
                errors.contact_emergency_phone = translate('forms.one_of_them_required');
                errors.contact_phone = translate('forms.one_of_them_required');
                errors.contact_whatsapp = translate('forms.one_of_them_required');
            } else if (contact_email) {
                errors.contact_email = validations.email(contact_email, values, props);
            }

            return errors;
        },
    }),
);

export default enhance(AccountsEditForm);



// WEBPACK FOOTER //
// ./src/pages/accounts/edit/AccountsEditForm.js